(function () {
  angular.module("akitabox.desktop.request").run(states);

  /* @ngInject */
  function states(models, Router) {
    var LIST_QUERY_PARAMS = models.SERVICE_REQUEST.QUERY_PARAMS.join("&");
    Router.configureStates([
      {
        state: "app.building.requests",
        config: {
          url:
            "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "?" + LIST_QUERY_PARAMS,
          templateUrl:
            "app/desktop/modules/request/building-list/request-list.html",
          controller: "RequestListController",
          controllerAs: "vm",
          data: {
            pageTitle: "Service Requests",
          },
          reloadOnSearch: true,
          resolve: {
            status: getStatus,
          },
        },
      },
      {
        state: "app.building.request",
        config: {
          url: "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "/:requestId",
          templateUrl: "app/desktop/modules/request/detail/request-detail.html",
          controller: "RequestDetailController",
          controllerAs: "vm",
          resolve: {
            request: getRequest,
            redirect: redirect,
          },
        },
      },
      {
        state: "app.requests",
        config: {
          url:
            "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "?" + LIST_QUERY_PARAMS,
          templateUrl:
            "app/desktop/modules/request/organization-list/org-request-list.html",
          controller: "OrganizationRequestListController",
          controllerAs: "vm",
          data: {
            pageTitle: "Service Requests",
          },
          reloadOnSearch: true,
          resolve: {
            status: getStatus,
          },
        },
      },
      {
        state: "app.request",
        config: {
          url: "/" + models.SERVICE_REQUEST.ROUTE_PLURAL + "/:requestId",
          templateUrl: "app/desktop/modules/request/detail/request-detail.html",
          controller: "RequestDetailController",
          controllerAs: "vm",
          resolve: {
            request: getOrganizationRequest,
            building: getBuilding,
            redirect: redirect,
          },
        },
      },
    ]);
  }

  /** @ngInject */
  function getOrganizationRequest(
    $state,
    $stateParams,
    account,
    organization,
    RequestService
  ) {
    var requestId = $stateParams.requestId;
    if (requestId === "create" || requestId === "new") {
      return $state.go("app.requests");
    }
    return RequestService.getByOrganization(organization._id, {
      _id: requestId,
    }).then(function (request) {
      return request;
    });
  }

  /** @ngInject */
  function getBuilding($stateParams, account, request, BuildingService) {
    return BuildingService.getById(request.building);
  }

  /** @ngInject */
  function getRequest($stateParams, account, building, RequestService) {
    return RequestService.getById(building._id, $stateParams.requestId);
  }

  /** @ngInject */
  function redirect($stateParams, $state, account, request, RedirectService) {
    var destination = RedirectService.getDestination();
    if (destination.match(/^.*\/work-order$/)) {
      if (angular.isEmpty(request.task)) {
        return $state.go("root.404");
      }
    } else if (destination.match(/^.*\/service-request$/)) {
      if (angular.isEmpty(request.level)) {
        return $state.go("root.404");
      }
    } else if (destination.match(/^.*\/room$/)) {
      if (angular.isEmpty(request.room)) {
        return $state.go("root.404");
      }
    } else if (destination.match(/^.*\/asset$/)) {
      if (angular.isEmpty(request.asset)) {
        return $state.go("root.404");
      }
    } else if (
      destination.match(/^\/([a-zA-Z0-9_]*\/){2}requests\/[a-zA-Z0-9]+$/)
    ) {
      return $state.go("app.building.request.overview", $stateParams);
    } else if (destination.match(/\/requests\/[a-zA-Z0-9]+$/)) {
      return $state.go("app.request.overview", $stateParams);
    }
  }

  /** @ngInject */
  function getStatus($stateParams, account, SERVICE_REQUEST_STATUS_NEW) {
    return $stateParams.status || SERVICE_REQUEST_STATUS_NEW;
  }
})();
